export default __webpack_public_path__ + "static/media/arrow-down.3128ecc9.svg";